import { MFASettings } from "@/components/admin/MFASettings";

export default function Security() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-heading font-bold">Security Settings</h1>
        <p className="text-muted-foreground">Manage your account security and multi-factor authentication.</p>
      </div>

      <div className="max-w-2xl">
        <MFASettings />
      </div>
    </div>
  );
}
